import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import { RECOMMENDATION_TYPES } from 'utils/Recommendation';

import ShoeAccessory from './ShoeAccessory';

const CartUpsell = class extends React.PureComponent {
  static propTypes = {
    config: PropTypes.shape({
      type: PropTypes.oneOf(Object.values(RECOMMENDATION_TYPES)),
    }),
    onMount: PropTypes.func,
  };

  static defaultProps = {
    config: null,
    onMount: () => {},
  };

  componentDidMount() {
    // Strange bug where firing something onMount breaks the transition group and makes the cart not slide open. Addin a timeout "fixes" the symptom.
    setTimeout(this.props.onMount, Theme.get('transition-duration'));
  }

  render() {
    const { config } = this.props;

    switch (get(config, ['type'])) {
      case RECOMMENDATION_TYPES.SHOE_ACCESSORY:
        return <ShoeAccessory {...this.props} />;
      default:
        return null;
    }
  }
};

export default CartUpsell;
